import LoginBanner from '../../../assets/images/banner_login.png'
import LoginBanner1 from '../../../assets/images/NWR-logo-darkbg_0.png'
import Logo from '../../../assets/images/reexoasset.png'
import Logo1 from '../../../assets/images/rexoerp_blue.png'
import UserLoginForm from '../../../components/forms/user_login/UserLoginForm'
import ForgetPasswordForm from '../../../components/forms/user_login/ForgetPasswordForm'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { ToastContainer } from 'react-toastify'

export const LoginImport = {
    LoginBanner,
    LoginBanner1,
    Logo,
    Logo1,
    UserLoginForm,
    ForgetPasswordForm,
    AOS,
    
}